/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { bool, shape, func } = proptypes;

import { extend } from '@thd-nucleus/data-sources';

import { BundleMiniContent } from '../../BundleMiniContent';
import { BundleProductsDataModel } from '../../../models/dataModel';
import { useBundleProducts } from '../../../hooks/useBundleProducts';
import { BundleMiniPlaceholder } from '../../BundleMiniPlaceholder';

export const BundleMiniItem = ({ bundleLoading = false, bundleData = {}, onError = () => { } }) => {
  const {
    productsData, loading: productsLoading, error
  } = useBundleProducts({ bundle: bundleData });

  const loading = productsLoading || bundleLoading;
  const renderMiniItem = bundleData && productsData && !error;

  useEffect(() => {
    if (!loading && !renderMiniItem) {
      onError();
    }
  }, [renderMiniItem, loading]);

  if (loading) {
    return <BundleMiniPlaceholder />;
  }

  if (!renderMiniItem) {
    return null;
  }

  return (
    <BundleMiniContent
      product={bundleData}
      products={productsData}
      removeBackgroundImage
    />
  );
};

BundleMiniItem.propTypes = {
  bundleLoading: bool,
  bundleData: shape({}),
  onError: func
};

BundleMiniItem.dataModel = extend(
  BundleProductsDataModel,
  BundleMiniContent
);